import { render, staticRenderFns } from "./teams.vue?vue&type=template&id=ed839cd2&scoped=true"
import script from "./teams.vue?vue&type=script&lang=js"
export * from "./teams.vue?vue&type=script&lang=js"
import style0 from "./teams.vue?vue&type=style&index=0&id=ed839cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed839cd2",
  null
  
)

export default component.exports